import { FC } from 'react';
import { SectionHeading } from '../SectionHeading';
import { BioForm } from './BioForm';

export const BioSection: FC = () => {
  return (
    <div className="flex flex-col gap-6">
      <SectionHeading>Bio</SectionHeading>

      <BioForm />
    </div>
  );
};
